import { render, staticRenderFns } from "./SavingsHistoryModal.vue?vue&type=template&id=15283fc4&"
import script from "./SavingsHistoryModal.vue?vue&type=script&lang=js&"
export * from "./SavingsHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./SavingsHistoryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports